import script from "./empowerAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./empowerAddress.vue?vue&type=script&setup=true&lang=js"

import "./empowerAddress.vue?vue&type=style&index=0&id=77cc6bdc&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77cc6bdc"]])

export default __exports__